import { Card, CardContent } from '@design-system/card';
import { formatMetricDisplay } from '../../helpers/metric-display';
import type { MetricCardsPresentation } from '../../types/presentation.types';

export function AgentMetricCards({
  block,
}: {
  block: MetricCardsPresentation;
}) {
  return (
    <div className='flex w-full max-w-full flex-col gap-2'>
      {block.title && (
        <div className='text-xs font-medium text-gray-700'>{block.title}</div>
      )}
      <div className='grid grid-cols-2 gap-2 sm:grid-cols-3'>
        {block.metrics.map((m, i) => {
          const { value, unit } = formatMetricDisplay(m);
          return (
            <Card
              key={`${m.label}-${i}`}
              className='min-w-0'
            >
              <CardContent className='flex flex-col gap-0.5 p-3'>
                <span className='truncate text-xs text-gray-500'>
                  {m.label}
                </span>
                <span className='flex items-baseline gap-1'>
                  <span className='text-lg font-semibold text-gray-900'>
                    {value}
                  </span>
                  {unit && (
                    <span className='text-xs text-gray-500'>{unit}</span>
                  )}
                </span>
                {m.delta !== undefined && m.delta !== '' && (
                  <span className='text-xs text-gray-500'>{m.delta}</span>
                )}
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
